<div id="modal-wrapper"
     [class.show]="modalShowing"
     [style.display]="modalShowing ? 'block' : 'none'"
     class="modal fade">
    <!-- Modal content here -->
</div>
